import React from 'react';
import {
  Props as TabProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';
import MedicationWebPage from 'pages/Dashboard/pages/Charts/pages/Details/components/ERx/MedicationWebPage';

type Props = Pick<TabProps, 'patient'>;

export default function Medications({ patient }: Props) {
  return (
    <div className="relative h-[calc(100%+36px)] -m-5">
      <MedicationWebPage patient={patient} />
    </div>
  );
}
